import React from "react";
import Header from "../../Components/Header/Header";
import BannerGlobal from "../../Components/Banner/BannerGlobal";
import Footer from "../../Components/Footer/Footer";
import CaseStudyDetailsCompo from "../../Components/CaseStudyComponent/CaseStudyDetailsCompo";
import TeamComponent from "../../Components/TeamComponent/TeamComponent";
import ReviewComponent from "../../Components/ReviewComponent/ReviewComponent";
import ContactComponent from "../../Components/ContactComponent/ContactComponent";
import useDocumentTitle from "../../PageTitle";

const CaseStudyDetails = () => {
  useDocumentTitle("Medical | CaseStudy Details")
  return (
    <div>
      <Header />
      <BannerGlobal />
      <CaseStudyDetailsCompo />
      <TeamComponent />
      <ReviewComponent />
      <ContactComponent />
      <Footer />
    </div>
  );
};

export default CaseStudyDetails;
